<template lang="pug">
div.w-full
  h3.text-sm.font-semibold.mb-3 User Details
  .grid.grid-cols-2.gap-4
    //- User ID
    div(v-if="data.id !== undefined")
      p.text-xs.text-muted-foreground.mb-1 User ID
      NuxtLink(:to="`/dashboard/${data.id}`" class="text-sm text-blue-600 hover:underline inline-flex items-center gap-1")
        | \#{{ data.id }}
        Icon(name="lucide:external-link" class="w-3 h-3")

    //- Organization
    div(v-if="data.org_id")
      p.text-xs.text-muted-foreground.mb-1 团队ID
      NuxtLink(:to="`/orgdashboard/${data.org_id}`" class="text-sm text-blue-600 hover:underline inline-flex items-center gap-1")
        | {{ data.org_id }}
        Icon(name="lucide:external-link" class="w-3 h-3")
    
    //- Email
    div(v-if="data.email")
      p.text-xs.text-muted-foreground.mb-1 Email
      p.text-sm {{ data.email }}
    
    //- Registration IP
    div(v-if="data.reg_ip")
      p.text-xs.text-muted-foreground.mb-1 Registration IP
      IPWithGeo(:ip="data.reg_ip" class="text-sm")
    
    //- Balance
    div(v-if="data.money !== undefined")
      p.text-xs.text-muted-foreground.mb-1 Balance
      p.text-sm.font-semibold {{ $utils.currency(data.money, data.balance_currency || 'EUR') }}
    
    //- Status
    div(v-if="data.extra")
      p.text-xs.text-muted-foreground.mb-1 Status
      p.text-sm.font-medium(:class="data.extra.suspend ? 'text-red-600' : 'text-green-600'")
        | {{ data.extra.suspend ? 'Suspended' : 'Active' }}
    
    //- Created
    div(v-if="data.created_at")
      p.text-xs.text-muted-foreground.mb-1 Created
      p.text-sm {{ $utils.dateStr(data.created_at) }}
    
    //- Updated
    div(v-if="data.updated_at")
      p.text-xs.text-muted-foreground.mb-1 Updated
      p.text-sm {{ $utils.dateStr(data.updated_at) }}
    
    //- Billing Name
    div(v-if="data.billing && (data.billing.firstname || data.billing.lastname)")
      p.text-xs.text-muted-foreground.mb-1 Billing Name
      p.text-sm {{ [data.billing.firstname, data.billing.lastname].filter(Boolean).join(' ') || '—' }}
    
    //- Site Domain
    div(v-if="data.site_domain")
      p.text-xs.text-muted-foreground.mb-1 Site Domain
      p.text-sm.font-mono {{ data.site_domain }}
  
  //- Complete non-sensitive JSON
  details.mt-6(open)
    summary.cursor-pointer.text-xs.text-muted-foreground(class="hover:text-foreground") Complete User Data
    pre.mt-2.p-3.text-xs.font-mono.whitespace-pre.border.rounded {{ jsonString }}
</template>

<script lang="ts" setup>
import IPWithGeo from '@/components/IPWithGeo.vue'

const props = defineProps<{
  data: any
}>()

const $utils = useUtils()

function userInspectJson(data: any): string {
  const sensitiveFields = new Set([
    'password',
    'token',
    'jwt_token',
    'crisp_hash',
    'email_token',
    'email_token2',
    'reset_token',
  ])
  return JSON.stringify(
    data,
    (key, value) => sensitiveFields.has(key) ? '[redacted]' : value,
    2,
  )
}

const jsonString = computed(() => userInspectJson(props.data))
</script>
